import _extends from "@babel/runtime/helpers/extends";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import ErrorPlaceholder from "../ErrorPlaceholder";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      pathname: props.location.pathname
    };
  }

  static getDerivedStateFromProps(props, prevState) {
    const {
      pathname
    } = props.location;

    if (pathname !== prevState.pathname) {
      return {
        pathname,
        hasError: false
      };
    }

    return null;
  }

  onReload(event) {
    event.preventDefault();
    window.location.reload();
  }

  componentDidCatch() {
    this.setState({
      hasError: true
    });
  }

  render() {
    const {
      hasError
    } = this.state;
    const {
      children,
      logoSrc,
      basicUrl
    } = this.props;

    if (hasError) {
      return /*#__PURE__*/React.createElement(ErrorPlaceholder, {
        logoSrc: logoSrc,
        basicUrl: basicUrl,
        title1: "Something",
        title2: "went wrong",
        desc:
        /*#__PURE__*/
        // eslint-disable-next-line
        React.createElement(React.Fragment, null, "Please\xA0", /*#__PURE__*/React.createElement("a", {
          onClick: this.onReload,
          href: "#"
        }, "reload"), "\xA0the page")
      });
    }

    return children;
  }

  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }

}

ErrorBoundary.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string
  }).isRequired,
  children: PropTypes.node.isRequired,
  logoSrc: PropTypes.string,
  basicUrl: PropTypes.string
};
ErrorBoundary.defaultProps = {
  logoSrc: null,
  basicUrl: null
};

const ErrorSimulator = () => {
  const [, setError] = useState();
  useEffect(() => {
    window.simulateError = () => {
      // eslint-disable-next-line
      setError(() => {
        throw new Error("I crashed!");
      });
    };
  }, []);
  return null;
};

__signature__(ErrorSimulator, "useState{[, setError]}\nuseEffect{}");

const ErrorBoundaryWithLocation = _ref => {
  let {
    children,
    ...props
  } = _ref;
  const location = useLocation();
  return /*#__PURE__*/React.createElement(ErrorBoundary, _extends({}, props, {
    location: location
  }), /*#__PURE__*/React.createElement(ErrorSimulator, null), children);
};

__signature__(ErrorBoundaryWithLocation, "useLocation{location}", () => [useLocation]);

ErrorBoundaryWithLocation.propTypes = {
  children: PropTypes.node.isRequired
};
const _default = ErrorBoundaryWithLocation;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ErrorBoundary, "ErrorBoundary", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/ErrorBoundary/ErrorBoundary.jsx");
  reactHotLoader.register(ErrorSimulator, "ErrorSimulator", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/ErrorBoundary/ErrorBoundary.jsx");
  reactHotLoader.register(ErrorBoundaryWithLocation, "ErrorBoundaryWithLocation", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/ErrorBoundary/ErrorBoundary.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/ErrorBoundary/ErrorBoundary.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();